import { useEffect, useSyncExternalStore } from "react";
import { getRecordingMergedAway, RecordingMergedAway, subscribeRecordingMergedAway } from "@/common/lib/recordingLease";
import { useInvalidateMergeState } from "@/state/hooks/useVisitMerges";
import { COPY } from "./copy";
import { OpenKeptVisitButton } from "./OpenKeptVisitButton";

/** The visit being recorded on, when the server refused its lease because it was merged away. */
export const useRecordingMergedAway = () =>
    useSyncExternalStore(subscribeRecordingMergedAway, getRecordingMergedAway, getRecordingMergedAway);

/**
 * EN-1196: shown in the recording widget when the visit being recorded on was merged into another one.
 * Recording carries on untouched; this only says where the clip will end up and how to get it back.
 */
export function MergedAwayRecordingNotice() {
    const merged = useRecordingMergedAway();
    return merged ? <Notice merged={merged} /> : null;
}

function Notice({ merged }: { merged: RecordingMergedAway }) {
    const invalidate = useInvalidateMergeState();
    // The page may still show this visit as unmerged: reload its merge state.
    useEffect(() => {
        invalidate();
    }, [merged, invalidate]);
    return (
        <div
            role="status"
            data-testid="recording-merged-away-notice"
            className="flex flex-col items-start gap-1 border-y border-tropicana-300 bg-tropicana-25 px-2 py-2 text-xs font-medium text-tropicana-950"
        >
            <span>{COPY.recordingMergedAway}</span>
            <OpenKeptVisitButton keptVisitId={merged.keptVisitId} className="font-bold text-max-900 underline" />
        </div>
    );
}
